export default __webpack_public_path__ + "static/1573-64932def4d24a1e2a56fba2ade2b75f0.gif";